import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_COMMON}`

const listPaginateCitys = (query = {}) => http.get(`${api}/city`, { params: { ...query } })

export default listPaginateCitys
